import { Dialog } from 'primereact/dialog';
import { Button } from '../../../../../../components/ui/Button';

import { useDispatch, useSelector } from 'react-redux';
import { toggleDialog } from '../../../../../../redux/Slices/Global/globalSlice';
import { useTranslation } from 'react-i18next';

function AdsConfirmation({ isLoading = false, itemName, adsHandler }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { deleteDialog, disableBtn } = useSelector((state) => state.global);
    const openDialog = useSelector((state) => state.global.openDialog);

    const confirmSwitch = () => adsHandler();
    const onClose = () => dispatch(toggleDialog("AdsConfirmation"))

    const footer = (
        <>
            <Button label={t('buttons.no')} icon="pi pi-times" className="p-button-text" disabled={isLoading} onClick={onClose} />
            <Button label={t('buttons.yes')}
                icon="pi pi-checks" className="p-button-text p-component p-confirm-dialog-accept p-button-danger"
                loading={isLoading} disabled={isLoading}
                onClick={confirmSwitch}
            />
        </>
    );

    return (
        <>
            <Dialog visible={openDialog.AdsConfirmation}
                style={{ width: '450px' }}
                breakpoints={{ '960px': '95vw' }}
                header={t('buttons.confirm')} modal
                footer={footer}
                onHide={onClose}>
                <div className="confirmation-content my-5">
                    <div className='text-center'>
                        <i className="pi pi-exclamation-triangle mr-3 d-block" style={{ fontSize: '2rem' }} />
                        <br />
                        {itemName == "screen" ?
                            <><span>{t('layouts.setup_ads_confirm_screen')}</span> <br /> <b>{t('layouts.setup_ads_confirm_screen_reset')}</b></>
                            :
                            <><span>{t('layouts.setup_ads_confirm_layout_off')}</span> <br /> <b>{t('layouts.setup_ads_confirm_layout_revert')}</b></>

                        }
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default AdsConfirmation